import { Segment } from '../types';
import { getClinicConfig } from '../clinicPalette';

interface Props {
  segments: Segment[];
  // Reference denominator for the bar's width — pass total_active so the
  // bar reflects the side's share of the overall active population, not
  // just its share within the stage. Per Shachar's spec: each bar's width
  // should be proportional to 100% of active patients across all stages.
  referenceTotal: number;
}

const fmt = (n: number) => n.toLocaleString('en-US');

export default function ButterflyBar({ segments, referenceTotal }: Props) {
  const sideTotal = segments.reduce((acc, s) => acc + s.count, 0);
  const barWidthPct = referenceTotal > 0 ? (sideTotal / referenceTotal) * 100 : 0;

  return (
    <div className="bf-fill-wrap">
      <div className="bf-fill" style={{ width: `${barWidthPct}%` }}>
        {segments.map((seg) => {
          const cfg = getClinicConfig(seg.clinic);
          const segWidthPct = sideTotal > 0 ? (seg.count / sideTotal) * 100 : 0;
          return (
            <div
              key={seg.clinic}
              className="bf-seg"
              title={`${cfg.displayName} · ${fmt(seg.count)}`}
              style={{ width: `${segWidthPct}%`, background: cfg.hex }}
            />
          );
        })}
      </div>
    </div>
  );
}
